/** APP 20260729-2-12312421*/
import useRefreshUserInfo from "hooks/useRefreshUserInfo";
import MyRouter from "routers/index";

function App() {
  useRefreshUserInfo();

  return (
    <div className="">
      <MyRouter />
    </div>
  );
}

export default App;
